import './styles.scss';
import React from 'react';
import { Responder } from '#root/queries/responders';
import { getEnumLabelByValue } from '#root/utils/enums';
import { RESPONDER_ROLES_CONST, USR_TEAMS } from '#root/utils/responders';
import { formatMileage, formatTimeSpan } from '#root/services/utils';
import LazyImage from '#root/components/LazyImage';

interface ResponderTravelCardProps {
    responder: Responder;
    onClick?: () => void;
}

export const ResponderTravelCard: React.FC<ResponderTravelCardProps> = ({
    responder,
    onClick
}) => {

    return (
        <div 
            className={`large-card time-and-travel-card ${onClick ? 'card-clickable' : ''}`} 
            onClick={onClick}
            role={onClick ? "button" : undefined}
        >
            <div className="person-card__content">
                <div className="person-image">
                    <LazyImage
                        src={responder.personalImageUrl}
                        fallback={<div className="person-image--no-image" />}
                    />
                </div>
                <div className="person-header">
                    <span className="person-name">{responder.firstName + ' ' + responder.lastName}</span>
                    <div className="person-divider"></div>
                    <span className="person-incident">{responder.departmentOrAgency}</span>
                </div>
                <div className="person-details">
                    <div className="person-row">
                        <div className="person-field">
                            <span className="large-card__label">Role: </span>
                            <span className="large-card__value">{getEnumLabelByValue(RESPONDER_ROLES_CONST, responder.role)}</span>
                        </div>
                        <div className="person-divider"></div>
                        <div className="person-field">
                            <span className="large-card__label">US&R Team: </span>
                            <span className="large-card__value">{getEnumLabelByValue(USR_TEAMS, responder.usarTeamNumber)}</span>
                        </div>
                        <div className="person-divider"></div>
                        <div className="person-field">
                            <span className="large-card__label">Total Time: </span>
                            <span className="large-card__value">{formatTimeSpan(responder.totalTime)}</span>
                        </div>
                        <div className="person-divider"></div>
                        <div className="person-field">
                            <span className="large-card__label">Total Mileage: </span>
                            <span className="large-card__value">{formatMileage(responder.totalMileage)}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
